var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcNavMap = function SvgIcNavMap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.207 3.697a.33.33 0 0 0-.34.334l.076 13.399a.33.33 0 0 0 .192.3l5.243 2.435a.33.33 0 0 0 .473-.302V6.501a.33.33 0 0 0-.192-.301l-5.32-2.472a.3.3 0 0 0-.132-.03m-1.562.075a.3.3 0 0 0-.135.031L9.045 6.342a.33.33 0 0 0-.192.303l.077 13.327a.332.332 0 0 0 .472.3l5.464-2.54a.33.33 0 0 0 .192-.302l-.076-13.327a.333.333 0 0 0-.337-.33M2.49 3.838a.33.33 0 0 0-.34.332v13.362a.33.33 0 0 0 .192.301l5.231 2.43a.333.333 0 0 0 .472-.302L7.967 6.562a.33.33 0 0 0-.192-.3L2.622 3.87a.3.3 0 0 0-.133-.03",
    clipRule: "evenodd"
  })));
};
export default SvgIcNavMap;